<template>
  <b-card :title="$t('state')" class="mb-4 project-state-card">
    <div class="info-grid">
      <div class="info-item">
        <span class="label">{{ $t('team') }}</span>
        <span class="value">
          <span v-if="project.newestInstallationAppointment">
            <div
              v-for="employee in project.newestInstallationAppointment.employees"
              :key="employee.number"
            >
              {{ employee.firstname }} {{ employee.lastname }}
            </div>
          </span>
          <span v-else>N/A</span>
        </span>
      </div>
      <div class="info-item">
        <span class="label">{{ $t('installationAt_short') }}</span>
        <span class="value">
          <span v-if="project.newestInstallationAppointment">
            {{ $datetime(project.newestInstallationAppointment.installationStartAt) }}
          </span>
          <span v-else>N/A</span>
        </span>
      </div>

      <div class="info-item">
        <span class="label">{{ $t('projectState') }}</span>
        <span class="value">
          <b-badge :variant="getProjectStateColor(project.projectState)">
            {{ $t(project.projectState) }}
          </b-badge>
        </span>
      </div>
      <div class="info-item info-item-empty" aria-hidden="true">
        <span class="label" :class="{ 'text-danger': isOutdated }">
          {{ $t('editing_state') }}
          <i v-if="isOutdated" class="fa fa-exclamation ml-1"></i>
        </span>
        <span class="value">
          <span v-if="isOutdated">
            {{ $t('project_outdated') }}
            {{ $t('please_reload') }}:
            <i @click="refreshPage" class="fa fa-lg fa-refresh ml-1 reload"></i>
          </span>
          <b-badge v-else :variant="getYesNoStateColor('YES')">
            {{ $t('project_data_current') }}
          </b-badge>
        </span>
      </div>

      <div
        v-if="
          projectEditingState &&
            projectEditingState.recentProjectUsers &&
            projectEditingState.recentProjectUsers.length > 0
        "
        class="info-item"
      >
        <span class="label current-users-label">{{ $t('current_users') }}</span>
        <span class="value current-users-value">
          <ul class="recent-users-list">
            <li v-for="audit in projectEditingState.recentProjectUsers" :key="audit._id">
              {{ $time(audit.createdAt) }}: {{ audit.user.firstname }} {{ audit.user.lastname }}
            </li>
          </ul>
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  getYesNoStateColor,
  getProjectStateColor,
  yesNoStateReversedColor,
} from '@/helpers/colors';
import { mapActions } from 'vuex';

export default {
  props: {
    project: { type: Object },
  },
  data() {
    return {
      projectEditingState: null,
      pollState: null,
      intervalInMilliseconds: 30000,
    };
  },
  computed: {
    isOutdated() {
      if (!this.projectEditingState) return false;
      return this.projectEditingState.projectIsOutdated;
    },
  },
  methods: {
    ...mapActions(['fetchProjectEditingState']),

    refreshPage() {
      location.reload();
    },

    async pollIsOutdated() {
      this.pollState = setInterval(async () => {
        this.projectEditingState = await this.fetchProjectEditingState(this.project.number);
      }, this.intervalInMilliseconds);
    },

    stopPolling() {
      clearInterval(this.pollState);
    },

    getYesNoStateColor,
    getProjectStateColor,
    yesNoStateReversedColor,
  },

  async mounted() {
    if (this.project.number && this.project.number !== '_new') {
      this.projectEditingState = await this.fetchProjectEditingState(this.project.number);
      await this.pollIsOutdated();
    }
  },

  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style scoped lang="scss">
// .project-state-card {
//   max-width: 30rem;
// }

.info-grid {
  display: grid;
  gap: 0.75em;
  grid-template-columns: auto auto;
  align-items: start;
  justify-content: start;

  @media (min-width: 1850px) {
    grid-template-columns: repeat(2, auto auto);
    column-gap: 1.5em;
    row-gap: 0.75em;
  }
}

.info-item {
  display: contents;

  .label {
    font-weight: 600;
    color: #6c757d;
    white-space: nowrap;
    align-self: start;
    margin-right: 0.5em;
  }

  .value {
    align-self: start;
  }
}

.popover-grid-container {
  display: grid;
  grid-template-columns: 4fr 1fr;
}
.popover-grid-container div {
  padding: 0.2em;
}
.popover-grid-container2 {
  display: grid;
  grid-template-columns: 1fr 4fr;
}
.popover-grid-container2 div {
  padding: 0.2em;
}

.recent-users-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

@media (min-width: 1850px) {
  .current-users-label {
    grid-column: 1;
  }

  .current-users-value {
    grid-column: 2 / -1;
  }
}

i.reload {
  color: $danger;
  cursor: pointer;
}
</style>
